module.exports = __webpack_public_path__ + "img/Vector_347_69064.7bd15f5f.png";